module.exports = __webpack_public_path__ + "img/mt.70146c19.png";